import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/Common/BreadCrumb/BreadCrumb";
import JobsHeader from "../../components/Common/JobsHeader/JobsHeader";
import Profile from "../../components/Profile/Profile";
import ProfileDetails from "../../components/ProfileDetails/ProfileDetails";
import "./Recommendation.scss";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { setProfile } from "../../redux/userReducer";

function Recommendation(props) {
  let {
    recommendedUsers,
    recommendedUserAbsolute,
    userSelectedProfile,
    userJobPostDetails,
  } = useSelector((state) => state.user);

 
  let dispatch = useDispatch();
  let [openProfileView, setOpenProfileView] = useState(
    Object.keys(userSelectedProfile)?.length > 1
  );
  const [hightLighted, setHighLighted] = useState();
  let [showProfileData, setShowProfileData] = useState(userSelectedProfile);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileDetailView, setMobileDetailView] = useState(false);

  // Check if screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  function showProfile(data) {
    dispatch(setProfile(data));
    setShowProfileData(data);
    
    if (isMobile) {
      setMobileDetailView(true);
    } else {
      setOpenProfileView(true);
    }
  }

  function closeMobileDetailView() {
    setMobileDetailView(false);
    setHighLighted(null);
  }

  // Mobile Detail View Component
  const MobileDetailView = () => (
    <motion.div
      className="mobile-detail-view"
      initial={{ x: "100%" }}
      animate={{ x: 0 }}
      exit={{ x: "100%" }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <div className="mobile-detail-header">
        <button 
          className="back-button"
          onClick={closeMobileDetailView}
        >
          ← Back
        </button>
        <h3>Profile Details</h3>
      </div>
      <div className="mobile-detail-content">
        <ProfileDetails
          showProfileData={showProfileData}
          setOpenProfileView={closeMobileDetailView}
          recommendedUserAbsolute={recommendedUserAbsolute}
          isMobile={true}
        />
      </div>
    </motion.div>
  );
  // Get all profiles to display
  const allProfiles = [
    ...recommendedUserAbsolute.slice(0, 5),
    ...recommendedUsers.slice(0, Math.max(0, 5 - recommendedUserAbsolute.length))
  ];

  return (
    <div className="recommendation-wrapper">
      <div className="recommendation-container">
            <JobsHeader title={"Recommendation"} />
            <BreadCrumb action={"Profile"} title={"Recommendation"} />

        {/* Mobile Detail View */}
        {isMobile && mobileDetailView && <MobileDetailView />}
          {/* <div className="recommendation-profiles">
          <div className="show-profile">
            {absoluteData?.map((data) => {
              return (
                <div
                  onClick={() => {
                    showProfile(data);
                    setHighLighted(data?.id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Profile data={data} hightLighted={hightLighted} absoluteData={absoluteData} />
                </div>
              );
            })}
          </div>

          <motion.div
            className="show-profile-details"
            animate={{
              x: openProfileView ? 0 : "100vw",
            }}
            transition={{
              duration: 0.5,
            }}
            style={{ display: openProfileView ? "" : "none" }}
          >
            <ProfileDetails
              showProfileData={showProfileData}
              setOpenProfileView={setOpenProfileView}
              absoluteData={absoluteData}
            />
          </motion.div>
        </div> */}
        
        {/* Main Content - hide when mobile detail view is open */}
        {!(isMobile && mobileDetailView) && (
          <div className={`recommendation-profiles ${isMobile ? 'mobile' : 'desktop'}`}>
            <div className="show-profile">
              {allProfiles.map((data, index) => (
                <div
                  key={data.id || index}
                  onClick={() => {
                    showProfile(data);
                    setHighLighted(data.id);
                  }}
                  className={`profile-item ${hightLighted === data.id ? 'highlighted' : ''}`}
                >
                  <Profile
                    data={data}
                    hightLighted={hightLighted}
                    recommendedUserAbsolute={recommendedUserAbsolute}
                  />
                </div>
              ))}
            {/* {recommendedUsers?.map((data) => {
              return (
                <div
                  onClick={() => {
                    showProfile(data);
                    setHighLighted(data?.id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Profile data={data} hightLighted={hightLighted} absoluteData={absoluteData} />
                </div>
              );
            })} */}
            </div>

            {/* Desktop Detail View */}
            {!isMobile && (
              <motion.div
                className="show-profile-details"
                animate={{
                  x: openProfileView ? 0 : "100vw",
                }}
                transition={{
                  duration: 0.5,
                }}
                style={{ display: openProfileView ? "" : "none" }}
              >
                <ProfileDetails
                  showProfileData={showProfileData}
                  setOpenProfileView={setOpenProfileView}
                  recommendedUserAbsolute={recommendedUserAbsolute}
                />
              </motion.div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Recommendation;
